import {createContext} from 'react';

const TNHContext = createContext({
    email: '',
    setEmail: () => {},
    hotline: '',
    setHotline: () => {},
    facebook: '',
    setFacebook: () => {},
    youtube: '',
    setYoutube: () => {},
    tiktok: '',
    setTiktok: () => {},
    pressTalkTnhId: '',
    setPressTalkTnhId: () => {},
    promotionId: '',
    setPromotionId: () => {},
    companyId: '',
    setCompanyId: () => {},
    newsCategories: [],
    setNewsCategories: () => {},
    businessData: [],
    setBusinessData: () => {},
    menuTop: [],
    setMenuTop: () => {},
    menuFooter: [],
    setMenuFooter: () => {},
    selectedDoctor: null,
    setSelectedDoctor: () => {},
});

export default TNHContext;
